import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useState } from "react";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import Dialog from "@mui/material/Dialog";
import Fab from "@mui/material/Fab";
/**
 * Displays
 * - zoom button if it is zoomable
 * - zoom dialog if zoomed in
 * - must be inside a container with `position: relative`
 * @param props
 * @returns
 *
 * @private
 */
export function ImageZoom(props) {
    const { isZoomable, imageUrl, imageAlt } = props;
    const [isZoomed, setIsZoomed] = useState(false);
    const zoomDialog = isZoomable && (_jsx(Dialog, { open: isZoomed, onClose: (e) => {
            e.stopPropagation();
            setIsZoomed(false);
        }, children: _jsx("img", { src: imageUrl, alt: imageAlt, onClick: (e) => {
                e.stopPropagation();
                setIsZoomed(false);
            } }) }));
    const zoomButton = isZoomable && (_jsx(Fab, { size: "small", "aria-label": "zoom", onClick: (e) => {
            e.stopPropagation();
            setIsZoomed(true);
        }, sx: {
            position: "absolute",
            top: "0.5rem",
            right: "0.5rem",
        }, children: _jsx(ZoomInIcon, {}) }));
    return (_jsxs(Fragment, { children: [zoomButton, zoomDialog] }));
}
//# sourceMappingURL=ImageZoom.js.map